import { LI, UL, Image } from "../../../../AbstractElements";
import { profileVector } from "../../../../Data/Profiledata/profiledata";
import { dynamicImage } from "../../../../Services/index";
import ProfileImageCard from "./ProfileImageCard";

const ProfileVector = ({ usersFirstLetter }) => {
  return (
    <div className="profile-vector">
      <UL attrUL={{ className: "dots-images simple-list" }}>
        {profileVector.map((item, i) => (
          <LI attrLI={{ className: `${item.classname} ` }} key={i}></LI>
        ))}
      </UL>
      <div className="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white fw-semibold mx-auto my-5"
        style={{ width: "150px", height: "150px", fontSize: "50px" }}
      >
        {usersFirstLetter}
      </div>
      {/* <Image attrImage={{ className: "img-fluid", src: dynamicImage("dashboard/default/profile.png"),}} alt="image"/> */}
      <ProfileImageCard />
    </div>
  );
};

export default ProfileVector;